<script setup lang="ts">
import { cva } from "class-variance-authority";
import { computed } from "vue";

import { useLayout } from "@/layout/common/composables/layout";
const props = defineProps({
  class: {
    type: String,
    default: "",
  },
});

const { calculatedMenuMode } = useLayout();

const sidebarGroupVariants = cva(
  "relative w-full flex flex-col gap-2 px-4 py-2",
  {
    variants: {
      variant: {
        horizontal: "flex-row !px-0 !py-5",
        drawer: "!px-2",
        reveal: "!px-2",
        slim: "!px-2",
        compact: "!px-2",
      },
    },
  },
);

type MenuMode = "drawer" | "reveal" | "slim" | "compact" | "horizontal";

const sidebarGroupClass = computed(() => {
  return sidebarGroupVariants({
    variant: calculatedMenuMode.value as MenuMode,
    class: props.class,
  });
});
</script>

<template>
  <div :class="sidebarGroupClass">
    <slot />
  </div>
</template>
